import { format, parseISO } from 'date-fns';

export const DATE_SCHEME_AU = 'dd/MM/yyyy';
export const DATE_SCHEME_US = 'MM/dd/yyyy';

export const formatDateDefault = (
  date: string | Date,
  scheme: string = DATE_SCHEME_AU,
) => {
  const finalDate = typeof date === 'string' ? parseISO(date) : date;

  return format(finalDate, scheme);
};
